"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unchangedOrLockedPost = exports.makeDebouncedSaveChangedComposition = exports.makeSaveChangedComposition = exports.saveChangedComposition = exports.getFinalCompositionData = void 0;

var _editorConfigs = require("composer-lib/lib/editorConfigs");

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _constants = require("composer-lib/lib/constants");

var _draftJs = require("draft-js");

var _debounce = _interopRequireDefault(require("transmute/debounce"));

var _utils = require("composer-lib/lib/utils");

var IDLE_DEBOUNCE_DURATION = 60000;
var SAVE_DEBOUNCE_DURATION = 3000; // prefer-const doesn't account for hoisting
// eslint-disable-next-line prefer-const

var debouncedIdleSave;

function parseDataForCompositionSave(data) {
  var parsedData = (0, _utils.immutablePick)(data, _constants.UPDATE_COMPOSITION_FIELDS);
  var body = JSON.stringify(data.getIn(['composeBody', 'body']));
  var compositionHtmlBody = data.getIn(['composeBody', 'htmlBody']);
  return parsedData.merge({
    body: body,
    compositionHtmlBody: compositionHtmlBody
  });
}

var getFinalCompositionData = function getFinalCompositionData(composerSettings, composition, saveState) {
  var content = saveState.content,
      summary = saveState.summary,
      title = saveState.title,
      titleChanged = saveState.titleChanged;
  var finalTitle = composition.get('type') === _constants.CompositionTypes.KNOWLEDGE_ARTICLE || composition.get('type') === _constants.CompositionTypes.PLAYBOOK ? title || (0, _utils.getTitlePlaceholder)(composition.get('typeString')) : title;
  var currentContent = content.getCurrentContent();
  var data = composition.get('data');
  data = data.merge({
    composeBody: {
      body: (0, _draftJs.convertToRaw)(currentContent)
    },
    title: finalTitle
  });

  if (composition.get('type') === _constants.CompositionTypes.KNOWLEDGE_ARTICLE) {
    return (0, _editorConfigs.asyncConvertToHTML)(composerSettings)(currentContent).then(function (htmlBody) {
      data = data.mergeDeep({
        composeBody: {
          htmlBody: htmlBody
        },
        summary: summary
      });
      return parseDataForCompositionSave(data);
    });
  }

  if (titleChanged) {
    // hard save when the title changes, otherwise write to the buffer. hard saves have other
    // hooks to update the content model and some other more expensive things, so write to the
    // buffer when we can
    data = data.set('buffer', false);
  }

  return Promise.resolve(parseDataForCompositionSave(data));
}; // Pass props from a Composer-connected component to save composition
// Necessary state data: auth, composerSettings, composition, lock, saveState
// Necessary actions: saveComposition, saveCompositionPending, showLockedModal


exports.getFinalCompositionData = getFinalCompositionData;

function _saveChangedComposition(props) {
  var auth = props.auth,
      composerSettings = props.composerSettings,
      composition = props.composition,
      lock = props.lock,
      saveState = props.saveState;
  var contentChanged = saveState.contentChanged,
      highlighted = saveState.highlighted,
      locked = saveState.locked,
      readOnly = saveState.readOnly,
      summaryChanged = saveState.summaryChanged,
      titleChanged = saveState.titleChanged;
  var lockedComposition = (0, _lockHelpers.compositionLocked)(lock, auth, saveState);
  var compositionReadOnly = composition.data.readOnly; // Reset idle save timer

  debouncedIdleSave(props);

  if (!contentChanged && !titleChanged && !summaryChanged || highlighted || locked || lockedComposition || readOnly || compositionReadOnly) {
    // if this is called from window.onbeforeunload it will get called a second time
    // when the debounced onChange handler is called, so we want to short-circuit the second
    // time around
    if (locked) {
      props.showLockedModal();
    }

    return Promise.resolve();
  }

  if (composition.get('type') === _constants.CompositionTypes.KNOWLEDGE_ARTICLE) {
    // Update UI to show save pending if we have to do an expensive convertToHTML before sending request
    props.saveCompositionPending();
  }

  return getFinalCompositionData(composerSettings, composition, saveState).then(function (data) {
    return props.saveComposition(data);
  });
}

var debouncedSaveChangedComposition = (0, _debounce.default)(SAVE_DEBOUNCE_DURATION, _saveChangedComposition);
debouncedIdleSave = (0, _debounce.default)(IDLE_DEBOUNCE_DURATION, _saveChangedComposition);
var saveChangedComposition = debouncedSaveChangedComposition; // Thunks so that we can pass right data to save without executing right away

exports.saveChangedComposition = saveChangedComposition;

var makeSaveChangedComposition = function makeSaveChangedComposition(props) {
  return function () {
    return _saveChangedComposition(props);
  };
};

exports.makeSaveChangedComposition = makeSaveChangedComposition;

var makeDebouncedSaveChangedComposition = function makeDebouncedSaveChangedComposition(props) {
  return function () {
    return debouncedSaveChangedComposition(props);
  };
};

exports.makeDebouncedSaveChangedComposition = makeDebouncedSaveChangedComposition;

var unchangedOrLockedPost = function unchangedOrLockedPost(_ref) {
  var auth = _ref.auth,
      lock = _ref.lock,
      saveState = _ref.saveState,
      showLockedModal = _ref.showLockedModal;
  var contentChanged = saveState.contentChanged,
      highlighted = saveState.highlighted,
      locked = saveState.locked,
      readOnly = saveState.readOnly,
      titleChanged = saveState.titleChanged;
  var lockedComposition = (0, _lockHelpers.compositionLocked)(lock, auth, saveState);

  if (!contentChanged && !titleChanged || highlighted || locked || lockedComposition || readOnly) {
    // if this is called from window.onbeforeunload it will get called a second time
    // when the debounced onChange handler is called, so we want to short-circuit the second
    // time around
    if (locked) {
      showLockedModal();
    }

    return true;
  }

  return false;
};

exports.unchangedOrLockedPost = unchangedOrLockedPost;